module.exports = __webpack_public_path__ + "img/mail.a8c7fc1f.svg";